<template>
  <div>
    <Logo></Logo>
    <!-- 返回栏，关于我们 -->
    <!-- <FirstHeader></FirstHeader> -->
    <div><img class="bg" :src="this.img.Image"/></div>
    <!-- 分割的距离 -->
    <!-- 四部分，企业概况，发展历程，企业文化，企业荣誉 定义id为map页面跳转对应锚点做准备 -->
    <div id="one" class="one">
    <!-- 企业概况 -->
    <div class="box1">
    <div class="detail">企业概况</div>
    <!-- 设置图片和标题重叠 -->
    <div class="layout">
        <div>
            <img class="img" src="../../assets/about/big.png">
        </div>
        <!-- 题目 -->
        <div class="title"><div style="margin-left:1.93rem;margin-top:.75rem">{{this.overview.title}}</div></div>  
    </div>    
    </div>
    <!-- 文章 -->
    <div class="text">
        <div class="text2">
            <div style="margin-left:1.625rem;margin-right:1.625rem;margin-bottom:4rem;"  v-html="this.overview.content">
                {{this.overview.content}}
            </div>
        </div>
    </div>
    </div>

    <!-- 发展历程 -->
    <!-- <div id='two' class="two">
        <div class="detail">发展历程</div>
          <div>
                <el-tabs v-model="activeName" >
                    <el-tab-pane v-for="(item,i) in lists" :key="i" :name="item.year.toString()" :label="item.year.toString()">
                        <div class="tit">{{item.dates}}</div> -->
                        <!-- v-if控制tab切换时渲染对应的子组件 -->
                        <!-- <component :is="item.name" :key="item.name" v-if="activeName === item.name"></component> -->
                        <!-- 是数组类型的 -->
                        <!-- <div style="display:flex;margin-top:2rem" v-for="(list,index) in (lists.desc)">
                            <img class="vector" src="../../assets/about/vector.png"></img>
                                <div>
                                    <img class="small" src="../../assets/about/small.png"></img>
                                    <div style="margin-top:1rem;font-size:1.5rem;color:#333333">{{item.year}}</div>
                                </div>
                        </div> -->
                        <!-- 是string类型的 -->
                        <!-- <div style="display:flex;margin-top:2rem">
                            <img class="vector" src="../../assets/about/vector.png"></img>
                                <div>
                                    <img class="small" src="../../assets/about/small.png"></img>
                                    <div style="margin-top:1rem;font-size:1.5rem;color:#333333">{{item.desc}}</div>
                                </div>
                        </div>
                    
                        
                    </el-tab-pane>
                </el-tabs>
          </div>

    </div> -->

    <!-- 企业文化 -->
    <div id="three" class="three">
        <div class="detail">企业文化</div>
        <div style="width:43.875rem;margin-top:4rem">
            <div class="boxes">
                <!-- 单数图片在左 -->
            <div style="display:flex;margin-bottom:4rem" class="left">
            <img class="future" :src="require('../../assets/about/culture1.png')" alt=""></img>
            <div class="text4">{{listss[0]}}</div>
            </div>
            <!-- 双数图片在右 -->
            <div style="display:flex;margin-bottom:4rem" class="right">
                <div class="text4">{{listss[1]}}</div>
                <img class="future" :src="require('../../assets/about/culture2.png')" alt=""></img>
            </div>
                            <!-- 单数图片在左 -->
            <div  style="display:flex;margin-bottom:4rem" class="left">
            <img class="future" :src="require('../../assets/about/culture3.png')" alt=""></img>
            <div class="text4">{{listss[2]}}</div>
            </div>
            <!-- 双数图片在右 -->
            <div  style="display:flex;margin-bottom:4rem" class="right">
                <div class="text4">{{listss[3]}}</div>
                <img class="future" :src="require('../../assets/about/culture4.png')" alt=""></img>
            </div>
            </div>
        </div>

    </div>

    <!-- 企业荣誉 -->
    <div id='four' class="four">
        <div class="detail">企业荣誉</div>
        <div style="margin-top:3rem">
            <img class="honor" src="../../assets/about/honor 1.png" alt="" />
            <div class="box4">
            <ul v-for="(list) in list" class="ul">
                <li class="li">
                    <img  class="dian" src="../../assets/about/dian.png"/>
                    <div>{{list.title}}</div>   
                </li>
            </ul>
            <router-link to="/about/honor" >
                <el-button class="bt" type="primary">查看更多</el-button>
            </router-link>
        </div>


        </div>

    </div>
    <div style="height:5.125rem;"><Tabbar></Tabbar></div>
  </div>
</template>

<script>
// import FirstHeader from '../../common/FirstHeader.vue'
import api from '@/utils/api'
import Tabbar from '../Index/Index_components/Tabbar.vue'
import Logo from "../Index/Index_components/logo.vue"
export default {
  name: 'AboutUs',
  components: {
    // FirstHeader,
    Tabbar,
    Logo,
  },
  data () {
    return {
      img: {
        Image: ''
      },
      overview: {},
      lists: [],
      activeName: '',
      list: [],
      listss: [
        '致力成为中国电子专用装备领域的领军企业',
        '为社会创造价值，为客户带来价值，让员工实现价值',
        '改进改善、精益求精',
        '团结、拼搏、求实、创新'
      ],
      listImg: ['../../assets/about/culture1.png', '../../assets/about/culture2.png', '../../assets/about/culture3.png', '../../assets/about/culture4.png']
    }
  },
  //   定义跳转到对应锚点(id)的方法
  created () {
    this.local()
    //   创建时执行跳转锚点位置
    this.$nextTick(() => { this.getlocal() })

  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('scroll', this.handleScroll)
    })
  },
  methods: {
    handleClick (tab, event) {
    },
    local () {
      var storage = window.localStorage
      if (!storage) {
        return false
      } else {
        if (storage.getItem('about')) {
          var about = JSON.parse(storage.getItem('about'))
          if (about.data1.code === 200) {
            this.img.Image = about.data1.data.image
          }

          if (about.data2.code === 200) {
            //获取概况数据
            this.overview = about.data2.data[0].overview
            //获取历史
            this.lists = about.data2.data[0].history
            this.activeName = this.lists[0].year.toString()
            //获取荣誉
            this.list = about.data2.data[0].honor
          }
          if (new Date().getTime() - about.time > 6500000) {
            storage.removeItem('about')
          }
        }
        else {
          this.getAbout()
        }
      }
    },
    async getAbout () {
      //获取顶部图片
      const { data: data1 } = await api.getAbout()
      const { data: data2 } = await api.getAboutDetail()
      var currTime = new Date().getTime()
      window.localStorage.setItem('about', JSON.stringify({
        data1: data1,
        data2: data2,
        time: currTime
      }))
      if (data1.code === 200) {
        this.img.Image = data1.data.image
      }
      console.log(data2.data[0])

      if (data2.code === 200) {
        //获取概况数据
        this.overview = data2.data[0].overview
        //获取历史
        this.lists = data2.data[0].history
        this.activeName = this.lists[0].year.toString()
        //获取荣誉
        this.list = data2.data[0].honor
      }


    },
    //   从本地找到id
    getlocal () {
      let select = localStorage.getItem('id');
      let elm = document.getElementById(select);
      if (select) {
        elm.scrollIntoView(true);
      }
    }
  },
  //   离开页面时对localStorage中的id进行销毁，避免其他入口进入的锚点进行扰乱
  destroyed () {
    localStorage.setItem('id', '')
  }
}
</script>
<style scoped>
/deep/ p > span {
  color: #333333 !important;
  font-size: 1.5rem !important;
  line-height: 2.1rem !important;
  margin-bottom: 0.625rem !important;
}
/deep/ p > span > span {
  color: #333333 !important;
  font-size: 1.5rem !important;
  line-height: 2.1rem !important;
  margin-bottom: 2.625rem !important;
}
/* 设置滑块大小 */
/deep/ .el-tabs__item {
  width: 6rem;
  margin-left: 4.3125rem;
  margin-right: 3.3125rem;
  height: 6rem;
  text-align: center;
  font-size: 1.5rem;
  background: #bebebe;
  color: #ffffff;
  border-radius: 6.25rem;
  text-align: center;
  padding-top: 1.75rem;
  padding-right: 2.6875rem !important;
  padding-left: 1.2rem !important;
}
.ul {
  display: flex;
  list-style-type: none;
}
.honor {
  width: 21.25rem;
  height: 23.75rem;
  float: right;
  margin-right: 3.25rem;
  margin-top: -2.625rem;
}
.li {
  font-size: 1.75rem;
  font-weight: bold !important;
  padding-top: 3rem;
  display: flex;
}
.box4 {
  width: 43.875rem;
  height: 43.875rem;
  background-color: #f5f5f5;
  margin-top: 2.125rem;
}
.dian {
  width: 0.875rem;
  height: 0.875rem;
  margin-top: auto;
  margin-bottom: auto;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.text4 {
  width: 25.5rem;
  margin: auto;
  font-size: 1.75rem;
  text-align: left;
}
.future {
  width: 15.875rem;
  height: 22.125rem;
}
.small {
  width: 20rem;
  height: 12.5rem;
}
.vector {
  width: 1.4375rem;
  height: 2.125rem;
  margin-right: 2.0175rem;
}
.layout {
  display: flex;
}
/* 顶部背景图片 */
.bg {
  width: 46.875rem;
  height: 14.75rem;
}
.img {
  width: 43.875rem;
  height: 23rem;
  margin-top: 2rem;
  position: relative;
}
.text {
  background-color: rgba(25, 127, 203, 0.47);
  width: 43.875rem;
}
.text2 {
  background-image: url("../../assets/about/bg.png");
  background-size: 100%;
  color: white;
  font-size: 1.5rem;
  text-align: center;
  padding-top: 1.0375rem;
  padding-bottom: 1.09rem;
}
.title {
  margin-top: 21.4rem !important;
  width: 43.875rem !important;
  height: 3.9375rem;
  background-color: #f5f5f5;
  color: #333333;
  transform: perspective(0.5rem) scale(1, 1.05) rotateX(0.2deg);
  transform-origin: bottom right;
  position: absolute;
  font-size: 1.75rem;
}
.bt {
  width: 12.25rem;
  height: 4.375rem;
  font-size: 1.5rem;
  margin-left: 15.8125rem;
  margin-right: 15.8125rem;
  border-radius: 0.5rem;
  margin-top: 4.4375rem;
}
/* one部分 */
.one {
  margin-left: 1.486875rem;
  margin-top: 6rem;
}
.detail {
  color: #333333;
  font-size: 2.125rem;
  font-weight: bold;
}
.two {
  margin-top: 6rem;
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.three {
  margin-top: 7.5rem;
  margin-left: 1.5rem;
}
.four {
  margin-top: 8.5rem;
  margin-left: 1.5rem;
  padding-bottom: 5rem;
}
/deep/ .el-icon-arrow-left:before {
  content: "\e6dd";
  font-size: 2.4375rem;
  color: #ff8d3d;
  font-weight: bold;
}
/deep/ .el-icon-arrow-right:before {
  content: "\e6dc";
  font-size: 2.4375rem;
  color: #ff8d3d;
  font-weight: bold;
}
/* 选中样式 */
/deep/ .el-tabs__item.is-active {
  background: -webkit-gradient(
    linear,
    100% 0%,
    0% 0%,
    from(#0aa9e5),
    to(#9fe5ff)
  ) !important;
  color: #ffffff;
  border-radius: 11.875rem;
}
/deep/ .el-tabs__active-bar {
  height: 0px;
}
/deep/ .el-tabs__nav-wrap::after {
  background-color: #ffffff;
}
/deep/ .el-tabs__nav-wrap.is-scrollable {
  margin-top: 2rem;
}
/* 文字小时间 */
.tit {
  margin-left: 3.9375rem;
  font-size: 1.75rem;
  color: #333333;
  padding-bottom: 1.5rem;
  margin-top: 4rem;
}
/* 设置位置icon */
/deep/ .el-tabs__nav-prev {
  left: 0.625rem;
  top: 1.75rem;
}
/deep/ .el-tabs__nav-next {
  top: 1.75rem;
  right: 0.625rem;
}
</style>
